<template>
  <div class="invite-users">
    <v-dialog v-model="dialog" max-width="550" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Invite users</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <v-combobox
              v-model="users"
              label="Invite users to this project"
              item-text="email"
              deletable-chips
              small-chips
              outlined
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :key="JSON.stringify(data.item)"
                  small
                  class="px-1 py-2"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    left
                    v-text="data.item.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item }}
                  <v-icon
                    class="pl-1"
                    small
                    @click="data.parent.selectItem(data.item)"
                    >mdi-close-circle</v-icon
                  >
                </v-chip>
              </template>
            </v-combobox>

            <v-btn
              color="primary"
              @click="inviteUsers"
              :loading="loading"
              class="white--text mr-1"
              depressed
              >Send</v-btn
            >
            <v-btn
              color="black"
              :disabled="loading"
              outlined
              depressed
              @click="$emit('close')"
              >Cancel</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      users: []
    };
  },
  watch: {
    users(val) {
      if (val && val.length) {
        const lastEmail = val[val.length - 1];

        if (
          // eslint-disable-next-line no-useless-escape
          /^[a-zA-Z0-9]+([\w\.\'\!\#\$\%\&\*\+\-\/\=\?\^\`\{\|\}\~])*([a-zA-Z0-9])+@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/.test(
            lastEmail
          )
        ) {
          return;
        } else {
          this.remove(lastEmail);
        }
      }
    }
  },
  methods: {
    remove(email) {
      this.users = this.users.filter(user => user !== email);
    },
    async inviteUsers() {
      if (this.users && this.users.length) {
        let total = this.users.length;
        const errors = [];

        for (let index = 0; index < this.users.length; index++) {
          const payload = {
            id: this.project.uuid,
            email: this.users[index]
          };

          this.loading = true;
          await this.$store
            .dispatch("project/inviteUsers", payload)
            .catch(() => {
              this.$store.commit(
                "setToast",
                {
                  message: `Invitee ${this.users[index]} has already been invited.`,
                  type: "error",
                  show: true
                },
                { root: true }
              );
              errors.push(this.users[index]);
            })
            .finally(() => {
              this.loading = false;
            });

          total = total - 1;

          if (total === 0 && errors.length < 1) {
            this.$emit("close");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>
